import React, { useEffect, useState } from "react";
import { Typography } from "@mhome/ui";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import { useRecoilValue } from "recoil";
import { scopePreferenceState, activeScopeState } from "../../global-state";

const TemperatureDetail1Widget = ({ widget, onValueUpdate }) => {
  const [temperature, setTemperature] = useState(0);
  const [unit, setUnit] = useState("C");
  const [isFlashing, setIsFlashing] = useState(false);
  const scopePreference = useRecoilValue(scopePreferenceState);
  const activeScope = useRecoilValue(activeScopeState);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const valueStr = widget.items.$w1.value;
      const numericValue = parseFloat(valueStr.replace(/[^0-9.-]/g, ""));
      const preferredUnit =
        scopePreference?.[activeScope]?.temperatureUnit || "C";
      const targetUnit = preferredUnit || widget.items.$w1.unit;
      setUnit(targetUnit);

      // Convert to target unit if needed
      let convertedTemp = numericValue;
      if (valueStr.toUpperCase().includes("F") && targetUnit === "C") {
        // Convert F to C
        convertedTemp = ((numericValue - 32) * 5) / 9;
      } else if (valueStr.toUpperCase().includes("C") && targetUnit === "F") {
        // Convert C to F
        convertedTemp = (numericValue * 9) / 5 + 32;
      }

      setTemperature(convertedTemp);
      setIsFlashing(true);
      setTimeout(() => setIsFlashing(false), 500);
    }
  }, [widget]);

  return (
    <div className="w-full flex flex-col gap-4">
      {/* Temperature Status Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between transition-colors duration-500"
        style={{
          height: "40px",
          backgroundColor: isFlashing
            ? "hsl(var(--primary))"
            : "hsl(var(--primary) / 0.8)",
        }}
      >
        <Typography className="text-white font-bold text-lg">
          {temperature.toFixed(1)} °{unit}
        </Typography>
        <div className="h-8 aspect-square flex items-center justify-center flex-shrink-0">
          <ThermostatIcon style={{ fontSize: "1.5rem", color: "white" }} />
        </div>
      </div>
    </div>
  );
};

export default TemperatureDetail1Widget;
